import React from 'react';
import { Switch, Route } from "react-router-dom";
import './App.css';

import CssBaseline from '@material-ui/core/CssBaseline';
import Home from './containers/Home';
import NotFound from './containers/NotFound';

export default () => (
  <div className="App">
    <CssBaseline />
    <Switch>
      <Route path="/:id" exact render={(props) => <Home {...props} type={`player`} />} />
      <Route path="/:id/player" exact render={(props) => <Home {...props} type={`player`} />} />
      <Route path="/:id/embed" exact render={(props) => <Home {...props} type={`embed`} />} />
      <Route  path="*" component={NotFound} />
    </Switch>
  </div>
);